import { SchemaFormFields } from '@mews-commander/form';
import { LocalizedText, lt } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { Banner, Stack, Title } from '@optimus-web/core';
import { schema } from './schema';
import { formDefinition } from './formDefinition';

export const AuditLogFormContent = () => (
    <Stack vertical spacing="200">
        <Banner
            secondaryText={<LocalizedText textKey={TextKey.GoLiveAuditsActivityLogDialogBannerText} />}
            variant="info"
        />
        <Title level={3}>{lt('AddNote')}</Title>
        <SchemaFormFields schema={schema} formDefinition={formDefinition} />
    </Stack>
);
